// extracted by mini-css-extract-plugin
module.exports = {"projectCards":"projects-module--projectCards--265jH"};